export default function isValidDate(date) {
    // eslint-disable-next-line no-restricted-globals
    return !isNaN(new Date(date));
}
